import type { ChartInterval, PostVisibility } from "@/adapters/api";

export const chartKeys = {
	construction: (constructionId: string | undefined) =>
		["charts", "construction", constructionId] as const,
	progress: (
		constructionId: string | undefined,
		referenceDate: string,
		interval: ChartInterval,
		stageId: string | undefined,
	) =>
		[
			...chartKeys.construction(constructionId),
			"progress",
			referenceDate,
			interval,
			stageId ?? null,
		] as const,
	measurements: (
		constructionId: string | undefined,
		referenceDate: string,
		interval: ChartInterval,
	) =>
		[
			...chartKeys.construction(constructionId),
			"measurements",
			referenceDate,
			interval,
		] as const,
	stageStatus: (constructionId: string | undefined, referenceDate: string) =>
		[
			...chartKeys.construction(constructionId),
			"stage-status",
			referenceDate,
		] as const,
	schedule: (constructionId: string | undefined) =>
		[...chartKeys.construction(constructionId), "schedule"] as const,
	recentPosts: (
		constructionId: string | undefined,
		visibility: PostVisibility | undefined,
	) => ["charts", "recent-posts", constructionId, visibility] as const,
	portfolios: () => ["charts", "portfolio"] as const,
	portfolio: (worksiteId: string | undefined, referenceDate: string) =>
		[...chartKeys.portfolios(), worksiteId, referenceDate] as const,
	attendance: (worksiteId: string | undefined, referenceDate: string) =>
		["charts", "attendance", worksiteId, referenceDate] as const,
};
